import { render } from "./AppointmentCancelDialog.vue?vue&type=template&id=edde4550&scoped=true"
import script from "./AppointmentCancelDialog.vue?vue&type=script&lang=js"
export * from "./AppointmentCancelDialog.vue?vue&type=script&lang=js"

import "./AppointmentCancelDialog.vue?vue&type=style&index=0&id=edde4550&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edde4550"]])

export default __exports__